import ServiceBase from '@/Services/ServiceBase';
import { locationRestrictedTypes } from '@/Components/Admin/Projects/PerformanceMarketing/PerformanceMarketingConstants';

export default class CampaignService extends ServiceBase {
    getAssetGroups(campaignId, includeSuggestions = false) {
        return this.request('get', `/campaign/${campaignId}/assetGroups`, { includeSuggestions });
    }

    createAssetGroup(campaignId, assetGroup) {
        return this.request('post', `/campaign/${campaignId}/assetGroups`, assetGroup);
    }

    extendActiveCampaign(campaignId, campaignData) {
        return this.request('post', `/campaign/${campaignId}/extend`, campaignData);
    }

    getCampaign(campaignId) {
        return this.request('get', `/campaign/${campaignId}`, null);
    }

    updateCampaign(campaignId, campaign) {
        return this.request('put', `/campaign/${campaignId}`, campaign);
    }

    useWalletBalance(campaignId) {
        return this.request('post', `/campaign/${campaignId}/useWalletBalance`, null);
    }

    getIssues(campaignId) {
        return this.request('get', `/campaign/${campaignId}/issues`, null);
    }

    getRecommendations(campaignId) {
        return this.request('get', `/campaign/${campaignId}/recommendations`, null);
    }

    getCampaignFunds(campaignId) {
        return this.request('get', `/campaign/${campaignId}/funds`, null);
    }

    getMaxSpendRange(startDate, endDate, budgetSpendingStrategyType, currencyShortName) {
        return this.request('get', '/campaign/maxSpendRange', { startDate, endDate, budgetSpendingStrategyType, currencyShortName });
    }

    getMaxSpend(startDate, endDate, maxDailySpend, budgetSpendingStrategyType, currencyShortName) {
        return this.request('get', '/campaign/maxSpend', { startDate, endDate, maxDailySpend, budgetSpendingStrategyType, currencyShortName });
    }

    getCreativeInsights(campaignId) {
        return this.request('get', `/campaign/${campaignId}/creativeInsights`, null);
    }

    getAdditionalDaysRemainingAfterTopUp(campaignId, topUpAmount) {
        return this.request('get', `/campaign/${campaignId}/additionalDaysRemainingAfterTopUp`, { topUpAmount });
    }

    getSpendingSimulation(budget, budgetSpendingStrategyType, endsAt, marketingEventEndsAt, marketingEventStartsAt, startsAt) {
        return this.request('get',
            '/campaign/spendingSimulation',
            { budget, budgetSpendingStrategyType, endsAt, marketingEventEndsAt, marketingEventStartsAt, startsAt });
    }

    getSpendingDistribution(campaignId) {
        return this.request('get', `/campaign/${campaignId}/spendingDistribution`, null);
    }

    deleteCampaign(campaignId) {
        return this.request('delete', `/campaign/${campaignId}`, null);
    }

    publishCampaign({
        campaignId,
        maxDailySpend,
        maxSpend,
        marketingEventEndsAt,
        marketingEventStartsAt,
        name,
        startsAt,
        endsAt,
        currencyShortName,
        launchCampaign,
    }) {
        return this.request('put', `/campaign/${campaignId}/publish`, { audienceSettings: {
            locationRestrictedType: locationRestrictedTypes.unlimited,
            restrictedLocationIsoCodes: [],
        }, maxDailySpend, maxSpend, marketingEventEndsAt, marketingEventStartsAt, name, startsAt, endsAt, currencyShortName, launchCampaign });
    }
    getCampaignRating(campaignId) {
        return this.request('get', `/campaign/${campaignId}/rating`);
    }

    getLocationInsights(campaignId, pageNumber = 1, pageSize = 10) {
        return this.request('post', `/campaign/${campaignId}/locationInsights`, { pageNumber, pageSize });
    }

    getAudiencePerformance(campaignId) {
        return this.request('get', `/campaign/${campaignId}/targetGroupInsights`, null);
    }

    getTargetGroups(campaignId) {
        return this.request('get', `/campaign/${campaignId}/targetGroups`, null);
    }

    getSupportedCurrencies() {
        return this.request('get', '/campaign/supportedCurrencies');
    }
}
